import React, { Component } from "react";
import Layout from "../header_footer/Layout";
import Jumbotron from "../utils/Jumbotron";
import Map from "../landing_page/contacts/Map";
import ContactoSmall from './ContactoSmall';
import axios from 'axios';

const divMorada = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  backgroundColor: "#529a76",
  height: "60px",
  padding: "0px 24px",
  borderBottomLeftRadius: "4px",
  borderBottomRightRadius: "4px",
};

const morada = {
  fontSize: "16px",
  color: "white",
  marginBottom: "0px",
};

const marginSubTitle = {
  margin: "24px 0px",
};

const contactStyle = {
  marginBottom: "30px",
};

class Contactos extends Component {

    constructor(props){
        super(props);
        this.state = {
            contactos: []
        }
    }

    componentDidMount(){
        this.loadContactos();
    }

    loadContactos = async () => {
        let res = {};
        try {
          res = await axios.get("/api/contactos", {
            params: {
              frontPage: false,
            },
            headers: {
              APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
              "Content-Type": "application/json",
            },
          });
        } catch (error) {
          console.log(error);
        }
    
        let contactos = [];
    
        if(res.data !== undefined && res.data.arrayContactos !== undefined) {
          contactos = res.data.arrayContactos;
        }
        
    
        this.setState({ contactos });
      };

  render() {
    
    const items = this.state.contactos.map(function (item) {
        return <ContactoSmall contacto={item} key={item.identifier}></ContactoSmall>;
      });

    return (
      <Layout>
        <Jumbotron title={"Contactos"}></Jumbotron>

        <div className="container">
          <div className="row">
            <div className="col-12">
              <Map />
              <div style={divMorada} className="morada-mapa">
                <p style={morada}>Bairro da Sardeira, 6270-151 Sabugueiro</p>
              </div>
            </div>
          </div>

          <p className="section-sub-title" style={marginSubTitle}>
            Contactos Úteis
          </p>

          <div className="row">
            {items}
          </div>
        </div>
      </Layout>
    );
  }
}

export default Contactos;
